import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { Typography } from '../../global/theme';
import { AlignCenter, FlexCenter } from '../../global/commonStyle';

interface PopoverWrapperProps {
  placement: 'top' | 'bottom' | 'left' | 'right';
  arrowLeft: string;
  arrowTop: string;
  top?: string | number;
  left?: string | number;
}

export const ColorSquaresWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
  ${mobile_xl(css`
    flex-wrap: wrap;
  `)}
`;

export const ColorSquare = styled.div<{ color: string; isActive: boolean }>`
  width: 64px;
  height: 64px;
  background-color: ${(props) => props.color};
  border-radius: var(--border-radius-4);
  cursor: pointer;
  transition: all var(--transition-fast) ease;
  &:hover {
    transform: scale(1.05);
  }
  ${mobile_xl(css`
    width: 54px;
    height: 54px;
  `)}
`;

export const Square = styled.div`
  position: relative;
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-6);
  p {
    margin: var(--space-0);
    ${Typography.body_lg_medium};
    color: var(--text-primary);
  }

  ${mobile_xl(css`
    flex-direction: row;
    gap: var(--space-12);
  `)}
`;

export const PopoverWrapper = styled.div<PopoverWrapperProps>`
  position: fixed;
  z-index: var(--z-index-modal);
  padding: var(--space-0);
  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : top || 'auto')};
  left: ${({ left }) => (typeof left === 'number' ? `${left}px` : left || 'auto')};
`;

export const Logo = styled.div`
  width: 64px;
  height: 64px;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  padding: var(--space-7);
  ${FlexCenter}
  cursor: pointer;
  position: relative;
  ${mobile_xl(css`
    width: 54px;
    height: 54px;
    padding: var(--space-3);
  `)}
`;

export const BottomDiv = styled.div`
  ${AlignCenter}
  flex-direction: column;
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;
